import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { AlertService } from '../../services/Alert/alert.service';
import { ApiService } from '../../services/API/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import 'owl.carousel'; 

@Component({
  selector: 'app-home-page-two',
  templateUrl: './home-page-two.component.html',
  styleUrls: ['./home-page-two.component.scss']
})
export class HomePageTwoComponent implements OnInit {

  menuItems: any[] = []
  offers: any[] = [];
  slides: any[][] = [];
  currentSlide = 0;
  featuredProducts: any[] = [
    {
      id: 1,
      name: 'Product 1',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$79.99',
      description: 'High-quality wireless headphones with noise cancellation.'
    },
    {
      id: 2,
      name: 'Product 2',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$199.99',
      description: 'Portable Bluetooth speaker with excellent sound quality.'
    },
    {
      id: 3,
      name: 'Product 3',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$49.99',
      description: 'Compact wireless earbuds with charging case.'
    },
    {
      id: 4,
      name: 'Product 4',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$24.99',
      description: 'Adjustable tablet stand for comfortable viewing.'
    },
    {
      id: 5,
      name: 'Product 5',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$19.99',
      description: 'Wireless headphones with noise cancellation.'
    },
    {
      id: 6,
      name: 'Product 6',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$59.99',
      description: 'Compact wireless earbuds with charging case.'
    },
    {
      id: 7,
      name: 'Product 7',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$29.99',
      description: 'Protective laptop sleeve with stylish design.'
    },
    {
      id: 8,
      name: 'Product 8',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$39.99',
      description: 'Multi-port USB-C hub for expanded connectivity.'
    },
    {
      id: 9,
      name: 'Product 9',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$34.99',
      description: 'Ergonomic wireless mouse with precision tracking.'
    },
    {
      id: 10,
      name: 'Product 10',
      image: 'https://dashboard.bayonnebbq.com/storage/images/products/1754227441.png',
      price: '$44.99',
      description: 'LED desk lamp with adjustable brightness.'
    }
  ];

  constructor(private alertService: AlertService,private apiService: ApiService) { }

  showSuccess() {
    this.alertService.success('Operation completed successfully!');
  }

  showError() {
    this.alertService.danger('Something went wrong!');
  }

  ngOnInit(): void {
    this.getData()
    this.getHomePageSubCategory()
    this.getAllCategories()
    this.generateSlides();
  }

  calculateProductsPerSlide(): number {
    const width = window.innerWidth;
    if (width < 576) return 1;   // Mobile
    if (width < 768) return 2;   // Small tablets
    if (width < 992) return 2;   // Tablets
    if (width < 1200) return 4;  // Small desktop
    return 4;                    // Large desktop
  }

  generateSlides() {
    const productsPerSlide = this.calculateProductsPerSlide();
    for (let i = 0; i < this.featuredProducts.length; i += productsPerSlide) {
      this.slides.push(this.featuredProducts.slice(i, i + productsPerSlide));
    }
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  }

  prevSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
  }

  goToSlide(index: number) {
    this.currentSlide = index;
  }

  addToCart(product: any) {
    console.log('Added to cart:', product);
    // Add your cart logic here
  }

  showCarousel: boolean = false;
  getData() {
    this.apiService.getHomePageData().subscribe({
      next: response => {
        this.offers = response.data.ads;
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  lunchCategoryId: any[] = []
  cateringCategoryId: any[] = []
  data: any
  cateringImage: string = ''
  lunchImage: string = ''
  getAllCategories(){
    this.apiService.getAllCategories().subscribe({
      next: response => {
        this.data = response.data
        this.cateringImage = this.data[0].avatar
        this.lunchImage = this.data[1].avatar
        this.lunchCategoryId = response.data.map(category => (category.name == 'Lunch' || category.name == 'Launch') == true ? category.id : null).filter(Boolean);
        this.cateringCategoryId = response.data.map(category => (category.name == 'Catering') == true ? category.id : null).filter(Boolean);
        // console.log(this.cateringCategoryId[0])
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  getHomePageSubCategory(){
    this.apiService.getHomePageSubCategory().subscribe({
      next: response => {
        this.menuItems = response.data;
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  lunchMenuItems: boolean = false
  cateringMenuItems: boolean = false
  showMenu(menu: string) {
    if(menu === 'lunch'){
      $('.lunchMenuItems-cateringMenuItems').addClass('d-none');
      $('.lunchMenuItems').removeClass('d-none');
      $('.cateringMenuItems').addClass('d-none');
      this.lunchMenuItems = true;
      this.cateringMenuItems = false;
    }
    else if(menu === 'catering'){
      $('.lunchMenuItems-cateringMenuItems').addClass('d-none');
      $('.cateringMenuItems').removeClass('d-none');
      $('.lunchMenuItems').addClass('d-none');
      this.cateringMenuItems = true;
      this.lunchMenuItems = false;
    }
  }

  showLunchCatringMenu(){
    $('.lunchMenuItems-cateringMenuItems').removeClass('d-none');
    $('.cateringMenuItems').addClass('d-none');
    $('.lunchMenuItems').addClass('d-none');
    this.lunchMenuItems = false;
    this.cateringMenuItems = false;
  }

  chunkArray(arr: any[], size: number): any[] {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  // Function to calculate empty cells
  getEmptyCells(row: any[]): any[] {
    return Array(5 - row.length).fill(null);
  }
}
